import { post } from '@web3/base-utils';
import {
  PostUnstakeFeeParams,
  PostUnstakeFeeRes,
  PostUnstakeParams,
  PostUnstakeEncodeParams,
  PostUnstakeEncodeRes,
  PostSaveUnstakeOrderParam,
  PostSaveUnstakeOrderRes,
  GetUnstakeAmountParamsV2,
  GetUnstakeAmountResV2,
  GetUnstakeEstimateTokenParam,
  GetUnstakeEstimateTokenRes,
  PostCancelEncodeParam,
  SaveCancelOrderParam,
} from '@/types/unstake';
import { baseApiUrl } from '@/config/api';
import { feeLevelMap } from '@/config/map';

export const postUnstakeFee = (params: PostUnstakeFeeParams) => {
  return post<PostUnstakeFeeRes>(`${baseApiUrl}/v2/order/unstake/fee`, {
    ...params,
    type: 'web',
    level: feeLevelMap[params.level || 'middle'],
    maxPriorityFeePerGas: 1,
    baseFee: 1,
  });
};

export const postUnstake = (params: PostUnstakeParams) => {
  return post<{ orderCode: string }>(`${baseApiUrl}/v2/order/unstake`, {
    ...params,
    type: 'web',
  });
};

export const postUnstakeEncode = (params: PostUnstakeEncodeParams) => {
  return post<PostUnstakeEncodeRes>(`${baseApiUrl}/v3/unstake/encode`, params, {
    useThirdConfig: true,
  });
};

export const postSaveUnstakeOrder = (params: PostSaveUnstakeOrderParam) => {
  return post<PostSaveUnstakeOrderRes>(
    `${baseApiUrl}/v3/unstake/saveUnstakeOrder`,
    params
  );
};
export const saveCancelOrder = (params: SaveCancelOrderParam) => {
  return post<PostSaveUnstakeOrderRes>(
    `${baseApiUrl}/v3/cancel/saveCancelOrder`,
    params
  );
};
export const postCancelEncode = (params: PostCancelEncodeParam) => {
  return post<PostUnstakeEncodeRes>(`${baseApiUrl}/v3/cancel/encode`, params);
};

export const getUnstakeAmountV2 = (params: GetUnstakeAmountParamsV2) => {
  return post<GetUnstakeAmountResV2>(`${baseApiUrl}/v2/account/lp/val`, params);
};

export const getUnstakeEstimateToken = (
  params: GetUnstakeEstimateTokenParam
) => {
  return post<GetUnstakeEstimateTokenRes>(
    `${baseApiUrl}/v3/unstake/estimateToken`,
    params,
    {
      useThirdConfig: true,
    }
  );
};
